export const formatCurrency = (amount: number, suffix: string | undefined) => {
  if (!suffix) {
    return "-"
  }

  const isEuroWithHalfValue =
    (suffix === "EUR" || suffix === "EUR/MON") && amount % 1 === 0.5

  const formattedAmount = Intl.NumberFormat("sv-SE", {
    minimumFractionDigits: isEuroWithHalfValue ? 2 : 0,
    maximumFractionDigits: isEuroWithHalfValue ? 2 : 0,
    currencyDisplay: "code",
  }).format(amount)

  return `${formattedAmount} ${suffix}`
}

export const formatCurrencyWithoutSuffix = (
  amount: number,
  suffix: string | undefined
) => {
  if (!suffix) {
    return "-"
  }

  const isEuroWithHalfValue =
    (suffix === "EUR" || suffix === "EUR/MON") && amount % 1 === 0.5

  const formattedAmount = Intl.NumberFormat("sv-SE", {
    minimumFractionDigits: isEuroWithHalfValue ? 2 : 0,
    maximumFractionDigits: isEuroWithHalfValue ? 2 : 0,
    currencyDisplay: "code",
  }).format(amount)

  return formattedAmount
}
